import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RegistrationService } from './services/registration.service' //is this neeed or can it be put higher up?
import {FormBuilder, FormGroup, Validators} from '@angular/forms';//can some of these be taken out as in module?
import { AuthService }      from '../auth.service';
import {Login} from "./login.interface";


@Component({
    // selector: 'app-login-form',
    templateUrl: './login-form.component.html',
    styleUrls: ['./registration-form.component.css']
})
export class LoginFormComponent implements OnInit {

    loginForm = <Login>{
        'username': '',
        'password': ''
    };
    public locations;
    errorMessage: string;
    loggedIn: boolean = false;
    loginStatus;
    statusMessage: object;
    disableSubmit = false;

    constructor(
        private authService: AuthService,
        private _registrationService: RegistrationService,
        private _formBuilder: FormBuilder,
        private _router: Router
    ) { this.statusMessage = { type: '', message: '' };
    }

    submitted = false;

    ngOnInit() {
        console.log('hello again `LoginForm` component');
    }

    login() {
        // if (this.loginForm.dirty && this.loginForm.valid) {
        //     //alert(`Username: ${this.loginForm.value.username} Password: ${this.loginForm.value.password}`);
        // }
        this._registrationService.loginUser(this.loginForm)
            .subscribe(
            data => {
                // console.log(data);
                this.loggedIn = true;
                this.loginStatus = data;
                this.authService.setLoggedIn();//set subscription to logged in
                let urlToNavigate = this.authService.redirectUrl || '/home';
                //alert(this.loginStatus.firstTimeLoggin);
                if (this.loginStatus.firstTimeLoggin) {
                    this._router.navigate(['/plan']);
                } //{window.location.href="/plan"}
                else {
                    this._router.navigate([urlToNavigate]);
                }
             },
            err => {
                if (err.status == "401") {
                    var jsErr = err.error;// to get error
                    this.errorMessage = "Error: " + jsErr.message;
                } else {
                    console.log(err); console.log(JSON.stringify(err, null, 2))
                }
            }, //let pJ = JSON.parse(err._body); alert(pJ.message);
            () => console.log('done')
            );
        //alert('after done');
        this.submitted = true;
        //this._router.navigate(['Home']); //don't need injection for router as it is injected at root componenet (jw)

    }

    // get value(): string {
    //     return JSON.stringify(this.loginForm.value, null, 2);
    // }

    // Prevent native `submit` events from POSTing beause this crashes APKs.
    greaseTrap(event) {
        event.preventDefault()
    }

}
